
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { FilePdfFill } from 'react-bootstrap-icons';
import {
  AttachFile,
  Description,
} from "@mui/icons-material"
import API from '../data/api';

export const handlePreviewIcon = (fileObject) => {
  const { type } = fileObject
  const iconProps = {
  }

  switch (type) {
    case "application/msword":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return <Description {...iconProps} />
    case "application/pdf":
      return <FilePdfFill color='purple' />
    default:
      return <AttachFile {...iconProps} />
  }
}

/**
 * Helper function to download a file from external site, without a progress indicator
 * 
 * @param {string} fileUrl - The url to download the file
 * @param {string} filename - The name of the file to download
 */
export const downloadFile = async (fileUrl, filename) => {
  if (!fileUrl) {
    return;
  }

  try {
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }
    const blob = await response.blob();
    handleFileBlob(blob, filename || 'download');
  } catch (error) {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    link.rel = 'noreferrer';
    if (filename) {
      link.download = filename;
    }
    link.click();
  }
};

/**
 * Helper function to download a file from API, without a progress indicator
 *
 * @param {string} fileUrl - The url to download the file
 * @param {string} filename - The name of the file to download
 */
export const downloadApiFile = async (fileUrl, filename, notifier = console.log) => {
  try {
    const response = await API.get(fileUrl, { responseType: 'arraybuffer' });
    const blobFile = new Blob([response?.data || null]);
    const _name = filename
        || response?.headers["content-disposition"]?.split("filename=")[1]
        || `download-${Date.now()}`;
    handleFileBlob(blobFile, _name);
  } catch (error) {
    notifier(error);
  }
};

export const handleFileBlob = (blob, filename) => {

  // Creating new object of PDF file
  const blobUrl = URL.createObjectURL(blob);

  // Setting various property values
  const alink = document.createElement("a");
  alink.href = blobUrl;
  alink.download = filename;
  alink.click();
  URL.revokeObjectURL(blobUrl);

};
